var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeadEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 91 91"
    },
    viewBox: "0 0 91 91",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.9,36.5c0.2-2.7-1.8-4.5-3.4-6.5c-0.9-1.1-1.8-2.2-2.7-3.3c1.8-1.8,3.7-3.5,5.5-5.4    c2.9-2.9-1.5-7.3-4.5-4.5c-1.8,1.7-3.6,3.5-5.3,5.3c-2.6-2.4-5.6-4.7-9-5.4c-2.3-0.5-4.1,2.3-2.3,4c2.2,2.2,4.6,4.1,6.8,6.2    c0,0,0,0,0,0c-2.8,3-6.2,6.3-7.7,10.2c-0.7,1.7,1.5,2.9,2.8,2.2c3.4-1.8,6.2-5.1,8.9-7.9c0.9,1.2,1.8,2.4,2.6,3.6    c0.4,0.6,1.8,2.6,1.8,2.5C33.5,41.4,36.7,38.6,36.9,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.1,16.8c-1.8,1.7-3.6,3.5-5.3,5.3c-2.6-2.4-5.6-4.7-9-5.4c-2.3-0.5-4.1,2.3-2.3,4c2.2,2.2,4.6,4.1,6.8,6.2    c0,0,0,0,0,0c-2.8,3-6.2,6.3-7.7,10.2c-0.7,1.7,1.5,2.9,2.8,2.2c3.4-1.8,6.2-5.1,8.9-7.9c0.9,1.2,1.8,2.4,2.6,3.6    c3.9,5.8,8.1,3.6,8.3,1.5c0.2-2.7-1.8-4.5-3.4-6.5c-0.9-1.1-1.8-2.2-2.7-3.3c1.8-1.8,3.7-3.5,5.5-5.4C79.4,18.4,75,14,72.1,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,59.2c2.8,3.9,3.6,9,0.2,12.8c-3.2,3.6-10,4.1-14.1,1.8c-3.7-2.1-4.4-7.2-3.8-11c1-5.6,4.5-7.5,9.5-9.1    c0.7-0.2,1-1.1,0.4-1.7c-2.3-2.6-6-2.2-8.8-0.8c-3.4,1.7-5.6,5-6.7,8.6c-2.1,6.5-0.5,14.9,5.5,18.9c6.2,4.2,16.4,3.5,21.8-1.6    c5.8-5.6,6-14.7,1.4-21.1C57.5,52.8,52.1,56,54.5,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.7,56.1c1.1,0,1.9-0.6,2.5-1.4c0,0,0-0.1,0.1-0.1c0.5-0.8,0.5-2,0-2.8c-0.5-0.9-1.4-1.3-2.4-1.4    c0,0-0.1,0-0.1,0c-1-0.1-2,0.6-2.5,1.4c-0.5,0.9-0.5,2,0,2.9C49.8,55.6,50.7,56.1,51.7,56.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeadEmoji);
export default __webpack_public_path__ + "static/media/icon-dead-emoji.6a971754.svg";
export { ForwardRef as ReactComponent };